import {
  isValidEmail,
  isValidPhoneNumber,
  isValidNumber,
  validateLength,
  dateFormate,
} from '../../../utils/helper';

export const staticLeadTableColumns = {
  phone_number: {
    key_name: 'phone_number',
    alias_name: 'Contact Details',
    key_type: 'PHONE',
    is_primary: true,
    is_static_column: true,
  },
  created_at: {
    key_name: 'created_at',
    alias_name: 'Created',
    key_type: 'STRING',
    is_primary: true,
    is_static_column: true,
  },
  'last_machadalo_comment.comment': {
    key_name: 'last_machadalo_comment.comment',
    alias_name: 'Comment',
    key_type: 'STRING',
    is_primary: true,
    is_static_column: true,
  },
  audio_summary: {
    key_name: 'audio_summary',
    alias_name: 'Audio Summary',
    key_type: 'STRING',
    is_primary: true,
    is_static_column: true,
  },
  aichat: {
    key_name: 'aichat',
    alias_name: 'AI Chat',
    key_type: 'STRING',
    is_primary: true,
    is_static_column: true,
  },
};

export const staticColumnsMatch = (formItems, staticColumns = staticLeadTableColumns) => {
  if (!Array.isArray(formItems)) return [];

  return formItems.filter((item) => !staticColumns?.[item?.key_name]?.is_static_column);
};

export const findTitleById = (id, options) => {
  try {
    const item = options.find((item) => item.id === id);
    return item?.title || 'Details';
  } catch (e) {
    return 'Details';
  }
};

export const groupLeadItems = (leadArray, groupOptions) => {
  const grouped: any = {};
  // console.log(leadArray, 'leadArrayleadArrayleadArray');
  // console.log(groupOptions, 'leadArrayleadArrayleadArray');

  try {
    leadArray.forEach((item) => {
      const title: string = findTitleById(item.groupId, groupOptions);
      if (!grouped[title]) {
        grouped[title] = [];
      }
      grouped[title].push(item);
    });
    const { Details, ...rest } = grouped;
    const ordered = { Details, ...rest };
    console.log(ordered, '0101010101010');
    return ordered;
  } catch (e) {
    console.log(e, 'eeee');
    console.log(grouped, 'groupedgroupedgroupedgrouped');

    return grouped;
  }
};

export const convertGroupFormIntoArr = (data) => {
  const singleArray = Object.values(data).flat();
  return singleArray || [];
};

export function validateDynamicForm(formData: Record<string, any[]>): ValidationResult {
  const fieldErrors: { [key: string]: string } = {};

  Object.entries(formData).forEach(([groupTitle, fields]) => {
    fields.forEach((item: any, idx: number) => {
      const isEmpty = item.value === '' || item.value === null || item.value === undefined;
      if (!item.is_primary && item.is_required && isEmpty) {
        fieldErrors[`${groupTitle}_${idx}`] = 'Field is required';
      }
    });
  });
  return {
    fieldErrors,
    hasErrors: Object.keys(fieldErrors).length > 0,
  };
}

export const validateFormFieldValue = (item: any, value: any) => {
  let errorMsg = '';
  if (item.key_type === 'EMAIL' && value && !isValidEmail(value)) {
    errorMsg = 'Please enter a valid email address.';
  }
  if (item.key_type === 'PHONE' && value && !isValidPhoneNumber(value)) {
    errorMsg = 'Please enter a valid phone number.';
  }
  if (item.key_type === 'TEXTAREA' && value) {
    errorMsg = validateLength(value, item.minLength, item?.maxLength);
  }
  if (item.key_type === 'STRING' && value && !(typeof value === 'string' && value?.trim() !== '')) {
    errorMsg = 'Please enter a valid string.';
  }
  if (item.key_type === 'INT' && value && !isValidNumber(value)) {
    errorMsg = 'Please enter a valid integer.';
  }
  if (item.key_type === 'PINCODE') {
    const pincodeRegex = /^[1-9][0-9]{5}$/;
    if (!pincodeRegex.test(value)) {
      errorMsg = 'Please enter a valid 6-digit pincode that does not start with 0.';
    }
  }

  return errorMsg;
};

export const sortFieldsByEntity = (fields: any = []) => {
  try {
    return fields.sort((a, b) => {
      if (a.key_type === 'ENTITY' && b.key_type !== 'ENTITY') {
        return 1;
      }
      if (a.key_type !== 'ENTITY' && b.key_type === 'ENTITY') {
        return -1;
      }
      return 0;
    });
  } catch {
    return fields;
  }
};

export const normalizeDateFormat = (dateStr: any) => {
  if (!dateStr) return '';
  try {
    const parsedDate = new Date(dateStr);
    if (!isNaN(parsedDate.getTime())) {
      return parsedDate.toISOString().slice(0, 10);
    }
    const match = dateStr.match(/^(\d{2})-(\d{2})-(\d{4})$/);
    if (match) {
      const [, day, month, year] = match;
      return `${year}-${month}-${day}`;
    }
  } catch (error) {
    return '';
  }
};

export function isLightColor(hex: string): boolean {
  const r = parseInt(hex.substr(1, 2), 16);
  const g = parseInt(hex.substr(3, 2), 16);
  const b = parseInt(hex.substr(5, 2), 16);
  const luminance = 0.299 * r + 0.587 * g + 0.114 * b;
  return luminance > 180;
}

export const updateDataWithFieldPermissions = (data, profileId = '') => {
  try {
    const updatedData = data.map((item) => {
      if (
        !item.settings ||
        !item.settings.permissions ||
        !Array.isArray(item.settings.permissions)
      ) {
        return item;
      }
      const userPermission = item?.settings?.permissions.find(
        (permission) => permission.id == profileId
      );
      if (userPermission && userPermission?.access_level) {
        return {
          ...item,
          access_level: userPermission?.access_level ?? 'none',
        };
      }
      return item;
    });

    return updatedData;
  } catch (e) {
    console.error('Error processing field permissions:', e);
    return data;
  }
};

export const updateFormObjectForColumnVisibility = (
  columnVisibility: Record<string, boolean>,
  webFormData: any,
  // userId: number
  profileId: string
) => {
  try {
    const cleanedColumnVisibility: Record<string, boolean> = {};
    Object.entries(columnVisibility).forEach(([key, value]) => {
      const cleanKey = key.replace(/^data\./, '');
      cleanedColumnVisibility[cleanKey] = value;
    });
    const updatedWebForm = JSON.parse(JSON.stringify(webFormData));
    Object.keys(updatedWebForm.leads_form_items || {}).forEach((itemKey) => {
      const item = updatedWebForm.leads_form_items[itemKey];
      const keyName = item?.key_name;
      if (cleanedColumnVisibility.hasOwnProperty(keyName)) {
        const isVisible = cleanedColumnVisibility[keyName];

        if (!item.settings) item.settings = {};
        if (!item.settings.column_visibility) item.settings.column_visibility = {};

        item.settings.column_visibility[profileId] = isVisible;
      }
    });
    return updatedWebForm;
  } catch (error) {
    console.error('Error updating form object for column visibility:', error);
    return webFormData;
  }
};
export const getColumnVisibilityFromFormObject = (webFormData: any, profileId: string) => {
  try {
    const columnVisibility: Record<string, boolean> = {};

    Object.keys(webFormData?.leads_form_items || {}).forEach((itemKey) => {
      const item = webFormData.leads_form_items[itemKey];
      const keyName = item?.key_name;
      const isStatic = item?.is_static_column === true;
      const finalKey = isStatic ? keyName : `${keyName}`;
      let isVisible = true;
      if (item?.settings?.column_visibility && profileId in item.settings.column_visibility) {
        isVisible = item.settings.column_visibility[profileId];
      }
      const userPermission = item?.settings?.permissions?.find(
        (permission) => permission.id == profileId
      );
      if (
        userPermission &&
        userPermission?.access_level &&
        userPermission?.access_level === 'none'
      ) {
        isVisible = false;
      }
      columnVisibility[finalKey] = isVisible;
    });
    return columnVisibility;
  } catch (error) {
    console.error('Error extracting column visibility from form object:', error);
    return {};
  }
};
